import {register} from '../vendor/theme-scripts/theme-sections';
import {compareImages} from '../features/compare-images';

register('before-after', [compareImages]);
